import React, { useState } from "react";
import PropTypes from "prop-types";

// components
import CheckoutForm from "core/CheckoutForm";
import DisclaimerBodyText from "subscriptions/components/DisclaimerBodyText";

// helpers
import { useCurrentUserContext } from "contexts/CurrentUserContext";
import { processTransaction } from "subscriptions/helpers";
import { useHistory } from "react-router-dom";
import { useElements, useStripe } from "@stripe/react-stripe-js";

// styles
import { FormContainer } from "subscriptions/styles";

// data
import {
    NOUN_PRO_EDU_CONFIRMATION_PAGE,
    NOUN_PRO_EDU_LANDING_PAGE
} from "data/links";
import {
    EDU_PRO_YEARLY_PLAN,
    subscribeURL,
    PRO_YEARLY_PLAN
} from "subscriptions/data";

const NounProEduForm = ({
    itemPrice,
    showOrderSummary,
    showError,
    setShowError,
    setForm,
    form
}) => {
    const history = useHistory();
    const stripe = useStripe();
    const elements = useElements();

    const [saveCard, setSaveCard] = useState(false);
    const [loading, setLoading] = useState(false);

    const {
        currentUser: { data }
    } = useCurrentUserContext();
    const { currentUser } = data;

    const handleFormChange = (value, fieldName) => {
        setForm({ ...form, [fieldName]: value });
        setShowError(null);
    };

    const submitFormWithNewCardInfo = async e => {
        e.preventDefault();

        if (!form.name) {
            return setShowError("Please fill out all required fields");
        }

        setLoading(true);

        const routeURL = `/${currentUser.username}${subscribeURL}`;

        const body = {
            plan: EDU_PRO_YEARLY_PLAN
        };

        const { formError, success } = await processTransaction(
            form,
            body,
            routeURL,
            stripe,
            elements
        );

        if (success) {
            setLoading(false);
            history.replace(NOUN_PRO_EDU_CONFIRMATION_PAGE);
        } else if (formError) {
            setLoading(false);
            setShowError(formError);
        }
    };

    const submitFormWithSavedCardInfo = e => {
        e.preventDefault();
        // TODO: add functionality
    };

    const saveCardCheckboxOnClick = () => {
        setSaveCard(!saveCard);
    };

    return (
        <>
            <FormContainer>
                <CheckoutForm
                    hideCardLinks
                    saveCardInitialValue={false}
                    isSubmitDisabled={false}
                    form={form}
                    showOrderSummary={showOrderSummary}
                    hasSavedCard={false}
                    saveCardCheckboxOnClick={saveCardCheckboxOnClick}
                    handleFormChange={handleFormChange}
                    submitFormWithNewCardInfo={submitFormWithNewCardInfo}
                    submitFormWithSavedCardInfo={submitFormWithSavedCardInfo}
                    generalFormError={showError}
                    cancelLink={NOUN_PRO_EDU_LANDING_PAGE}
                    submitText={"Start Subscription"}
                    itemPrice={itemPrice}
                    loading={loading}
                />
            </FormContainer>
            <DisclaimerBodyText licenseSelection={PRO_YEARLY_PLAN} />
        </>
    );
};

NounProEduForm.propTypes = {
    itemPrice: PropTypes.number.isRequired,
    showOrderSummary: PropTypes.bool.isRequired,
    setShowError: PropTypes.func.isRequired,
    showError: PropTypes.string.isRequired,
    setForm: PropTypes.func.isRequired,
    form: PropTypes.shape({
        name: PropTypes.string,
        address_zip: PropTypes.string,
        receipt_info: PropTypes.string
    })
};

export default NounProEduForm;
